// extracted by mini-css-extract-plugin
module.exports = {"Application":"Application_Application__3_UF2"};